var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUserLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#003d5b;}.b,.c,.e{fill:none;}.b,.c{stroke:#003d5b;}.b{stroke-width:2px;}.d{stroke:none;}.f{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 5.5,
    y: 8.5,
    width: 31,
    height: 30,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#004850",
    floodOpacity: 0.141
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.356 -0.499)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, 0.36, 0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 11,
    cy: 10.5,
    rx: 11,
    ry: 10.5,
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(4.356 4.499)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 16.5,
    cy: 16.5,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 16.5,
    cy: 16.5,
    r: 15.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0.356 0.499)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 21,
    cy: 21,
    r: 21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 21,
    cy: 21,
    r: 20.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserLocation);
export default __webpack_public_path__ + "static/media/iconUserLocation.a033227620fdb9415c826258d2bb9cc9.svg";
export { ForwardRef as ReactComponent };